"use strict";
/**
 * AuditEntry — immutable audit trail for financial records and other entities.
 *
 * This model represents a persisted audit entry capturing changes to domain entities
 * (create, update, delete operations). It is used by the financial-records feature
 * and other services to maintain an append-only audit trail for compliance and
 * auditability.
 *
 * The entry follows the shape already persisted by the existing `writeAuditEntry`
 * service in `shared/src/services/audit-trail.ts` and is read by the `audit-trail`
 * Lambda via the `byEntityType` GSI.
 *
 * Requirements: 13.1, 13.2, 13.3
 */
Object.defineProperty(exports, "__esModule", { value: true });
